<div class="screen">
  <div class="main">
    <div class="image">
      <img
          src="{{assetPath}}imgs/404/404-background.png"
          class="background">
      <img
          src="{{assetPath}}imgs/404/404-cloud.gif"
          class="cloud">
    </div>
    <h1>Whoops…</h1>
    <p>It looks like you’re lost.<br>You may have an old link or maybe the page was moved.</p>
  </div>
</div>
